let domReferences = null;

export function getDomElements() {
    if (domReferences) return domReferences;

    // Cache DOM references
    domReferences = {
        pageContent: document.getElementById("page-content"),
        navbar: document.getElementById("navbar"),
        cartButton: document.querySelector(".fa-shopping-cart"),
        cartSection: document.getElementById("cart-section"),
        closeCartButton: document.querySelector(".cart__close-btn"),
        cartContents: document.querySelector(".cart__contents"),
        footer: document.querySelector("footer")
    };

    return domReferences;
}
export function updateMetaTags(metaTags) {
    if (!metaTags || !Array.isArray(metaTags)) return;

    metaTags.forEach(metaTag => {
        const selector = metaTag.name
            ? `meta[name="${metaTag.name}"]`
            : `meta[property="${metaTag.property}"]`;

        let existingTag = document.querySelector(selector);

        if (existingTag) {
            existingTag.setAttribute('content', metaTag.value);
        } else {
            let newTag = document.createElement('meta');
            if (metaTag.name) {
                newTag.setAttribute('name', metaTag.name);
            } else if (metaTag.property) {
                newTag.setAttribute('property', metaTag.property);
            }
            newTag.setAttribute('content', metaTag.value);
            document.head.appendChild(newTag);
        }
    });
}

// Update meta tags for the current page
export function updatePageMetaTags(content, pageName) {
    if (!content || !Array.isArray(content)) return;

    // Get the content for the current page
    const pageContent = content.find(item => item.name === pageName);

    // Update page title
    updatePageTitle(pageContent, content);

    // Update page meta tags
    let metaTags = [];
    if (pageContent && pageContent.meta_tags) {
        metaTags = [...pageContent.meta_tags];
    } else {
        // Fall back to homepage meta tags
        const homepageContent = content.find(item => item.name === "homepage");
        if (homepageContent && homepageContent.meta_tags) {
            metaTags = [...homepageContent.meta_tags];
        }
    }

    // Ensure og:url is set to current URL
    if (metaTags.length > 0) {
        // Look for existing og:url tag
        const ogUrlIndex = metaTags.findIndex(tag =>
            tag.property === 'og:url'
        );

        if (ogUrlIndex !== -1) {
            // Update existing og:url tag
            metaTags[ogUrlIndex] = {
                property: 'og:url',
                value: window.location.href
            };
        } else {
            // Add og:url tag if it doesn't exist
            metaTags.push({
                property: 'og:url',
                value: window.location.href
            });
        }

        // Update all meta tags
        updateMetaTags(metaTags);
    }
}

function updatePageTitle(pageContent, content) {
    try {
        if (pageContent?.details) {
            const pageTitle = pageContent.details.find(detail => detail?.name === "title");

            if (pageTitle?.content_type === "text" && pageTitle?.value) {
                document.title = pageTitle.value;
                return;
            }
        }

        // Fall back to homepage title
        setDefaultTitle(content);
    } catch (error) {
        console.warn("Error setting page title:", error);
        document.title = "Site Title";
    }
}

function setDefaultTitle(content) {
    if (!content || !Array.isArray(content)) {
        document.title = "Site Title";
        return;
    }

    const homepageContent = content.find(item => item?.name === "homepage");

    if (homepageContent?.details) {
        const homepageTitle = homepageContent.details.find(
            detail => detail?.name === "title" && detail?.content_type === "text"
        );

        if (homepageTitle?.value) {
            document.title = homepageTitle.value;
            return;
        }
    }

    // Fallback
    document.title = "Site Title";
}